import { PortfolioAboutIDE, PortfolioHomeIDE, PortfolioProjectsIDE } from '@/components/ide/portfolio-ide';
import { ComponentFileData, GameFileData, IframeFileData, ProjectData } from '@/types';
import { generateIframeFiles } from '@/utils/file-data';

// Portfolio Project
const portfolioFiles: (ComponentFileData | IframeFileData)[] = [
    {
        id: 'portfolio-index',
        name: 'index.html',
        path: 'portfolio/index.html',
        type: 'component',
        content: PortfolioHomeIDE,
    },
    {
        id: 'portfolio-about',
        name: 'about.html',
        path: 'portfolio/about.html',
        type: 'component',
        content: PortfolioAboutIDE,
    },
    {
        id: 'portfolio-projects',
        name: 'projects.html',
        path: 'portfolio/projects.html',
        type: 'component',
        content: PortfolioProjectsIDE,
    },
    {
        id: 'portfolio-contact',
        name: 'contact.html',
        path: 'portfolio/contact.html',
        type: 'iframe',
        content: '/contact.html',
        sandbox: 'allow-same-origin allow-scripts allow-forms',
    },
];

// PC Blog Project (generated via helper)
const pcBlogFiles = generateIframeFiles('pc-blog', 'https://kingfaris.co.uk', [
    { id: 'index', name: 'index.html', subpath: '/' },
    { id: 'blogs', name: 'blogs.html', subpath: '/blogs' },
    { id: 'faq', name: 'faq.html', subpath: '/faq' },
    { id: 'overclocking-cpu', name: 'overclocking-cpu.html', subpath: '/overclocking/cpu' },
    { id: 'overclocking-ram', name: 'overclocking-ram.html', subpath: '/overclocking/ram' },
]);

// Games Project
const gamesFiles: GameFileData[] = [
    {
        id: 'snake-game',
        name: 'snake-game.html',
        path: 'games/snake-game.html',
        type: 'game',
        game: 'snake-game',
    },
    {
        id: 'tic-tac-toe',
        name: 'tic-tac-toe.html',
        path: 'games/tic-tac-toe.html',
        type: 'game',
        game: 'tic-tac-toe',
    },
    {
        id: 'memory-game',
        name: 'memory-game.html',
        path: 'games/memory-game.html',
        type: 'game',
        game: 'memory-game',
    },
    {
        id: 'breakout-game',
        name: 'breakout-game.html',
        path: 'games/breakout-game.html',
        type: 'game',
        game: 'breakout-game',
    },
    {
        id: 'word-scramble',
        name: 'word-scramble.html',
        path: 'games/word-scramble.html',
        type: 'game',
        game: 'word-scramble',
    },
];

// Default Projects Configuration
export const DEFAULT_PROJECTS: ProjectData[] = [
    {
        id: 'portfolio',
        name: 'Portfolio',
        description: 'Main portfolio website',
        isExpanded: true,
        files: portfolioFiles,
    },
    {
        id: 'pc-blog',
        name: 'PC Blog',
        description: 'Personal blog project',
        isExpanded: true,
        files: pcBlogFiles,
    },
    {
        id: 'games',
        name: 'Games',
        description: 'Collection of web games',
        isExpanded: true,
        files: gamesFiles,
    },
];
